/**
 * Graph Spec Viewer - Route Component
 *
 * Wrapper for OntologyGraphExplorer that extracts jobId from route params.
 * Renders Neo4j-style graph visualization for GraphSpec v1.0.
 *
 * @module client/views/GraphSpecViewer
 * @version 1.2
 * @date 2025-10-18
 */

import * as React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { OntologyGraphExplorer } from "../components/OntologyGraphExplorer";

/**
 * Graph Spec Viewer Component
 *
 * Route component at /analysis/:job_id/graph-spec
 * Supports diff mode via ?compare=:previous_job_id query parameter
 *
 * Usage:
 * - /analysis/job-123/graph-spec → FAIR Compliance Map
 * - /analysis/job-456/graph-spec?compare=job-123 → Diff mode
 */
export function GraphSpecViewer(): React.ReactElement {
  const { job_id } = useParams<{ job_id: string }>();
  const [searchParams] = useSearchParams();
  const compareJobId = searchParams.get("compare") ?? undefined;

  if (!job_id) {
    return (
      <div className="error-container">
        <h1>Missing Job ID</h1>
        <p>No job ID provided in URL. Expected format: /analysis/:job_id/graph-spec</p>
      </div>
    );
  }

  return <OntologyGraphExplorer jobId={job_id} compareJobId={compareJobId} />;
}
